import { apiAlbumToBPMAlbum, toSortBy } from "src/transformer";
import { GenericClassicSmartViewProps, default as GenericClassicSmartView, GenericClassicSmartViewHOC } from "./GenericClassicSmartView";
import { QuerySearchParameters, Genre, Category, RemixQueryOptions, PagingInfo } from "bpm-client-api";
import { SongVersion, SortBy, ContentType, BPMAlbum } from 'bpm-web-generic';
import { albumAPI, mediaAPI } from "src/api/config";
import { SortByQueryOptions } from "src/api/download-api-sdk/src";

export interface NewReleasesProps extends GenericClassicSmartViewProps { }

interface NewReleasesState {
    apiFilter: QuerySearchParameters
    categories: Category[]
    genres: Genre[]
    songVersions: SongVersion[]
    sortBys: SortBy[]
    keys: string[]
    categorized_albums?: BPMAlbum[][]
    top10: BPMAlbum[]
}
class NewReleasesInner extends GenericClassicSmartView<NewReleasesProps, NewReleasesState>{

    constructor(props: NewReleasesProps) {
        super(props);
    }

    protected loadAlbumsForCategory(_: ContentType, filter: QuerySearchParameters, pagingInfo: PagingInfo) {
        return mediaAPI.searchAlbum(pagingInfo.limit, pagingInfo.skip, filter.category, `music`, filter.sub_genre, undefined, filter.remix == RemixQueryOptions.Hide ? '1' : '0', filter.show_only, filter.key, undefined, filter.bpm_min, filter.bpm_max, toSortBy(filter.sort_by) || SortByQueryOptions.DateDesc, filter.keywords).then((data: any) => {
            return {
                ...data,
                data: data.data.map(apiAlbumToBPMAlbum)
            }
        })
    }

    protected loadAlbums(_: ContentType, filter: QuerySearchParameters) {
        return albumAPI.getAlbumsForCategory(filter.category, `music`, filter.sub_genre, undefined, filter.remix == RemixQueryOptions.Hide ? '1' : '0', filter.show_only, filter.key, undefined, filter.bpm_min, filter.bpm_max, toSortBy(filter.sort_by) || SortByQueryOptions.DateDesc, filter.keywords).then((data) => {
            return {
                ...data,
                data: data.data.map(apiAlbumToBPMAlbum),
                pagination: {
                    page: 1, total: 1
                }
            }
        })
    }

    protected loadAlbumsPerCategory() {
        return this.loadAlbums('audio', this.state.apiFilter)
    }

    protected getContext(): string {
        return 'New Releases'
    }

    protected getTitle(): string {
        return 'New Releases'
    }

    protected hideListItemNumber() {
        return true;
    }

}

export const NewReleases = GenericClassicSmartViewHOC(NewReleasesInner)



// WEBPACK FOOTER //
// ./src/pages/NewReleases.tsx